import PeopleLifestyleArticleMobile from './people_lifestyle_article_mobile'
import PeopleLifestyleArticleDesktop from './people_lifestyle_article_desktop'

const PeopleLifestyleArticle = ({
  is_mobile,
  title,
  slug_url,
  link_cta,
  section_name,
  dataArticle,
}) => {
  const props = {
    is_mobile: is_mobile || false,
    dataArticle: Array.isArray(dataArticle) ? dataArticle : [],
    title: title || 'People',
    slug_url: slug_url,
    link_cta:
      link_cta ||
      process.env.NEXT_PUBLIC_ROOT_DOMAIN,
    section_name: section_name || 'people',
  }

  if (props.is_mobile) {
    return <PeopleLifestyleArticleMobile {...props} />
  } else {
    return <PeopleLifestyleArticleDesktop {...props} />
  }
}

export default PeopleLifestyleArticle
